import script from "./Format.vue?vue&type=script&setup=true&lang=js"
export * from "./Format.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__